import type { ValorBrowserTokenizationSession } from '@anchorbase/pillar-sdk/ipg/valor/payment';

export type ValorCardTokenizationQueryParamsInput = {
    delegateToken: ValorBrowserTokenizationSession;
    normalizedPan: string;
    normalizedExpiryDate: string;
};

export const buildValorCardTokenizationQueryParams = (
    input: ValorCardTokenizationQueryParamsInput
): URLSearchParams =>
    new URLSearchParams({
        epi: input.delegateToken.epi,
        txn_type: 'cardToken',
        client_token: input.delegateToken.client_token,
        pan: input.normalizedPan,
        expirydate: input.normalizedExpiryDate,
        cctoken: '',
    });
